/** @jsxImportSource @emotion/react */
import { Checkbox as MUICheckbox } from '@mui/material';
import { createStyles } from '../../';

interface Props {
  name?: string;
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  testId?: string;
}

export const Checkbox = ({
  name,
  checked,
  onChange,
  disabled,
  testId,
}: Props) => {
  const styles = useStyles();

  return (
    <MUICheckbox
      disableRipple
      disableTouchRipple
      onChange={() => onChange && onChange(!checked)}
      icon={<span css={[styles.default, styles.unchecked]} />}
      checked={checked}
      css={[styles.default, styles.checked]}
      disabled={disabled}
      data-testid={testId}
      inputProps={{ name }}
    />
  );
};
const useStyles = createStyles(({ palette, spacing }) => ({
  default: {
    width: spacing.xs,
    height: spacing.xs,
    padding: spacing.xxxs,
  },
  checked: {
    '&.Mui-checked': {
      color: palette.primary.default,
    },
  },
  unchecked: {
    borderRadius: '2px',
    backgroundColor: palette.grey.x100,
    border: `1px solid ${palette.grey.x300}`,
    width: spacing.xxs,
    height: spacing.xxs,
  },
}));
